import {Component, inject, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";

import {CarPart} from "../../../../enums/car-part";
import {ClaimsService} from "../../../../services/claims.service";

@Component({
  selector: 'app-car-parts-being-involved',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './car-parts-being-involved.component.html',
  styleUrl: './car-parts-being-involved.component.css'
})
export class CarPartsBeingInvolvedComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private fb = inject(FormBuilder);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, value: string }[] = [
    {
      headline: this.locale.currentTranslation.carPartsInvolvedOptionHeadline1,
      value: CarPart.Front
    },
    {
      headline: this.locale.currentTranslation.carPartsInvolvedOptionHeadline2,
      value: CarPart.Left
    },
    {
      headline: this.locale.currentTranslation.carPartsInvolvedOptionHeadline3,
      value: CarPart.Back
    },
    {
      headline: this.locale.currentTranslation.carPartsInvolvedOptionHeadline4,
      value: CarPart.Right
    },
    {
      headline: this.locale.currentTranslation.carPartsInvolvedOptionHeadline5,
      value: CarPart.Top
    }
  ];
  optionsForm: FormGroup = this.fb.group({
    selectedOptions: this.fb.array([])
  });

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      const selectedParts = this.claimService.claimReport().involvedCarParts || [];
      const selectedOptions = this.optionsForm.get('selectedOptions') as FormArray;

      selectedParts.forEach((part: string) => {
        selectedOptions.push(new FormControl(part));
      });
    })
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({involvedCarParts: this.optionsForm.value.selectedOptions})
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['car-parts-involved']);
      });
    }
  }

  private evaluateShowError() {
    this.showError = this.optionsForm.value.selectedOptions.length === 0;
  }

  setOption(e: any) {
    const selectedOptions: FormArray = this.optionsForm.get('selectedOptions') as FormArray;

    if (e.target.checked) {
      selectedOptions.push(this.fb.control(e.target.value));
    } else {
      const index = selectedOptions.controls.findIndex(x => x.value === e.target.value);
      if (index >= 0) {
        selectedOptions.removeAt(index);
      }
    }

    this.showError = false
  }

  isSelected(value: string): boolean {
    const fa = this.optionsForm.get('selectedOptions') as FormArray;
    return fa.value.includes(value);
  }
}
